import { Button, ButtonGroup, ColourStateSolid, Tooltip, useTranslation } from '@ukpostbox/frontend-framework';
import { faList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faGrid } from '@fortawesome/pro-solid-svg-icons/faGrid';
import React from 'react';
import { MailboxFilter } from './Toolbars/Controls/MailboxFilter';
import { MailboxInfo } from './Drawers/MailboxInfo';
import { useMailbox } from '../Providers/NewMailboxProvider';

function MailboxActions() {
	const { t } = useTranslation();
	const { gridView, SetGridView } = useMailbox();

	return (
		<>
			<MailboxInfo />
			<ButtonGroup tipChildren verticalCenter>
				<Tooltip content={t('mailboxes.actions.listView')}>
					<Button
						title={t('mailboxes.actions.listView')}
						squared
						iconOnly
						icon={faList}
						colour={!gridView ? ColourStateSolid.Success : ColourStateSolid.Secondary}
						onClick={() => SetGridView(false)}
					/>
				</Tooltip>
				<Tooltip content={t('mailboxes.actions.gridView')}>
					<Button
						title={t('mailboxes.actions.gridView')}
						squared
						iconOnly
						icon={faGrid}
						colour={gridView ? ColourStateSolid.Success : ColourStateSolid.Secondary}
						onClick={() => SetGridView(true)}
					/>
				</Tooltip>
			</ButtonGroup>
			<MailboxFilter />
		</>
	);
}

export { MailboxActions };
